import Swal from "sweetalert2";

export const authNotAdminAlert = () => {
  Swal.fire({
    title: "권한이 없습니다!",
    text: "관리자 계정으로 로그인 하시기 바랍니다.",
    icon: "warning", // 경고 아이콘
    confirmButtonText: "확인",
    timer: 5000,
  }).then((result) => {
    if (result.isConfirmed || result.dismiss) {
      // 확인 버튼 클릭 또는 타이머 만료 시 실행
      window.location.href = "/#/login"; // 이동할 경로
    }
  });
};
